/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { Component, ComponentRef, ElementRef, EmbeddedViewRef, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { ElComponentPortal, ElPortalOutletDirective, ElTemplatePortal } from '../cdk/overlay/mapping';
import { ElFocusTrap, ElFocusTrapFactoryService } from '../cdk/a11y/focus-trap';
import { ElDialogConfig } from './dialog-config';


/**
 * Container component for each dialog.
 * All the dialogs will be attached to it.
 * // TODO add animations
 * */
@Component({
    selector: 'el-dialog-container',
    template: '<ng-template elPortalOutlet></ng-template>',
})
export class ElDialogContainerComponent implements OnInit, OnDestroy {

    // TODO static must be false as of Angular 9.0.0, issues/1514
    @ViewChild(ElPortalOutletDirective, { static: true }) portalOutlet: ElPortalOutletDirective;

    protected focusTrap: ElFocusTrap;

    constructor(protected config: ElDialogConfig,
        protected elementRef: ElementRef,
        protected focusTrapFactory: ElFocusTrapFactoryService) {
    }

    ngOnInit() {
        if (this.config.autoFocus) {
            this.focusTrap = this.focusTrapFactory.create(this.elementRef.nativeElement);
            this.focusTrap.blurPreviouslyFocusedElement();
            this.focusTrap.focusInitialElement();
        }
    }

    ngOnDestroy() {
        if (this.config.autoFocus && this.focusTrap) {
            this.focusTrap.restoreFocus();
        }
    }

    attachComponentPortal<T>(portal: ElComponentPortal<T>): ComponentRef<T> {
        return this.portalOutlet.attachComponentPortal(portal);
    }

    attachTemplatePortal<C>(portal: ElTemplatePortal<C>): EmbeddedViewRef<C> {
        return this.portalOutlet.attachTemplatePortal(portal);
    }
}
